'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _partnerRegistration = require('redux/modules/partnerRegistration');

var actions = _interopRequireWildcard(_partnerRegistration);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validatePhone = function validatePhone(Phone) {
  /* reg exp để kiểm tra xem chuỗi có chỉ bao gồm 10 - 11 chữ số hay không */
  var regexp = /^\d{10,11}$/;
  var checkingResult = regexp.exec(Phone);
  if (checkingResult !== null) {
    return true;
  }
  return false;
};
var partnerRegistration = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    success: state.partnerRegistration.success,
    loading: state.partnerRegistration.loading,
    error: state.partnerRegistration.error,
    errorMessage: state.partnerRegistration.errorMessage
  };
}, (0, _extends3.default)({}, actions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(partnerRegistration, _Component);

  function partnerRegistration() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, partnerRegistration);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = partnerRegistration.__proto__ || (0, _getPrototypeOf2.default)(partnerRegistration)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      name: '',
      nameError: false,
      address: '',
      addressError: false,
      website: '',
      websiteError: false,
      customerName: '',
      customerNameError: false,
      businessModel: '',
      businessModelError: false,
      position: '',
      positionError: false,
      phoneNumber: '',
      phoneNumberError: false,
      email: '',
      error: false,
      redirect: false
    }, _this.handleInputName = function (event) {
      var value = event.target.value;

      _this.setState({ name: value });
    }, _this.handleInputNameValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ nameError: true });
      } else {
        _this.setState({ nameError: false });
      }
    }, _this.handleInputAddress = function (event) {
      var value = event.target.value;

      _this.setState({ address: value });
    }, _this.handleInputAddressValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ addressError: true });
      } else {
        _this.setState({ addressError: false });
      }
    }, _this.handleInputWebsite = function (event) {
      var value = event.target.value;

      _this.setState({ website: value });
    }, _this.handleInputWebsiteValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ websiteError: true });
      } else {
        _this.setState({ websiteError: false });
      }
    }, _this.handleInputModel = function (event) {
      var value = event.target.value;

      _this.setState({ businessModel: value });
    }, _this.handleInputModelValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ businessModelError: true });
      } else {
        _this.setState({ businessModelError: false });
      }
    }, _this.handleInputModel = function (event) {
      var value = event.target.value;

      _this.setState({ businessModel: value });
    }, _this.handleInputModelValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ businessModelError: true });
      } else {
        _this.setState({ businessModelError: false });
      }
    }, _this.handleInputCustomer = function (event) {
      var value = event.target.value;

      _this.setState({ customerName: value });
    }, _this.handleInputCustomerValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ customerNameError: true });
      } else {
        _this.setState({ customerNameError: false });
      }
    }, _this.handleInputPosition = function (event) {
      var value = event.target.value;

      _this.setState({ position: value });
    }, _this.handleInputPositionValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ positionError: true });
      } else {
        _this.setState({ positionError: false });
      }
    }, _this.handleInputPhone = function (event) {
      var value = event.target.value;

      _this.setState({ phoneNumber: value });
    }, _this.handleInputPhoneValidation = function (event) {
      var value = event.target.value;

      if (value === undefined || value === '') {
        _this.setState({ phoneNumberError: !validatePhone(value) });
      } else {
        _this.setState({ phoneNumberError: !validatePhone(value) });
      }
    }, _this.handleInputEmail = function (event) {
      var value = event.target.value;

      _this.setState({ email: value });
    }, _this.handleSetDataWillSent = function () {
      var _this$state = _this.state,
          name = _this$state.name,
          nameError = _this$state.nameError,
          address = _this$state.address,
          addressError = _this$state.addressError,
          website = _this$state.website,
          websiteError = _this$state.websiteError,
          customerName = _this$state.customerName,
          customerNameError = _this$state.customerNameError,
          businessModel = _this$state.businessModel,
          businessModelError = _this$state.businessModelError,
          position = _this$state.position,
          positionError = _this$state.positionError,
          phoneNumber = _this$state.phoneNumber,
          phoneNumberError = _this$state.phoneNumberError,
          email = _this$state.email;

      if (name === '' || address === '' || website === '' || customerName === '' || businessModel === '' || position === '' || phoneNumber === '' || nameError || addressError || websiteError || customerNameError || businessModelError || positionError || phoneNumberError) {
        _this.setState({ error: true });
        _this.setState({ success: false });
      } else {
        _this.setState({ error: false });
        var data = {
          name: name,
          address: address,
          website: website,
          customerName: customerName,
          businessModel: businessModel,
          position: position,
          phoneNumber: phoneNumber,
          email: email
        };
        _this.handleSentData(data);
      }
    }, _this.handleSentData = function (data) {
      _this.props.submitDataPartner(data);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }
  // Validation + trim()


  (0, _createClass3.default)(partnerRegistration, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.success) {
        this.setState({ redirect: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          name = _state.name,
          address = _state.address,
          website = _state.website,
          businessModel = _state.businessModel,
          customerName = _state.customerName,
          position = _state.position,
          phoneNumber = _state.phoneNumber,
          email = _state.email,
          error = _state.error,
          redirect = _state.redirect;
      var _state2 = this.state,
          nameError = _state2.nameError,
          addressError = _state2.addressError,
          websiteError = _state2.websiteError,
          businessModelError = _state2.businessModelError,
          customerNameError = _state2.customerNameError,
          positionError = _state2.positionError,
          phoneNumberError = _state2.phoneNumberError;
      var _props = this.props,
          success = _props.success,
          errorMessage = _props.errorMessage;

      if (redirect) {
        _reactRouter.browserHistory.push('/cam-on');
      }
      var loading = this.props.loading;
      var styles = require('./Partner.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.wrapContainer },
        _react2.default.createElement(
          'div',
          { className: styles.title },
          '\u0110\u0103ng k\xED tr\u1EDF th\xE0nh \u0111\u1ED1i t\xE1c c\u1EE7a',
          ' ',
          _react2.default.createElement(
            'span',
            { className: styles.hightlight },
            'LOOKME'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.container },
          _react2.default.createElement(
            'div',
            { className: styles.decription },
            'Vui l\xF2ng \u0111i\u1EC1n \u0111\u1EA7y \u0111\u1EE7 th\xF4ng tin, Lookme s\u1EBD li\xEAn h\u1EC7 v\u1EDBi b\u1EA1n v\xE0 t\u1EA1o t\xE0i kho\u1EA3n tr\xEAn h\u1EC7 th\u1ED1ng sau khi x\xE1c nh\u1EADn'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.location },
            '1. Th\xF4ng tin \u0111\u1ECBa \u0111i\u1EC3m'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'T\xEAn \u0111\u1ECBa \u0111i\u1EC3m ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: name,
              onChange: this.handleInputName,
              onBlur: this.handleInputNameValidation
            }),
            nameError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              'T\xEAn kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              '\u0110\u1ECBa ch\u1EC9 ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: address,
              onChange: this.handleInputAddress,
              onBlur: this.handleInputAddressValidation
            }),
            addressError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              '\u0110\u1ECBa ch\u1EC9 kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'Website ho\u1EB7c link Facebook c\u1EE7a \u0111\u1ECBa \u0111i\u1EC3m',
              ' ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: website,
              onChange: this.handleInputWebsite,
              onBlur: this.handleInputWebsiteValidation
            }),
            websiteError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              '\u0110\u1ECBa ch\u1EC9 Website ho\u1EB7c link kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'M\xF4 h\xECnh kinh doanh ch\xEDnh (Ch\u0103m s\xF3c da/Massage/L\xE0m m\xF3ng/...)',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: businessModel,
              onChange: this.handleInputModel,
              onBlur: this.handleInputModelValidation
            }),
            businessModelError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              'M\xF4 h\xECnh kinh doanh kh\xF4ng \u0111\u01B0\u1EE3c b\u1ECF tr\u1ED1ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.location },
            '2. Th\xF4ng tin li\xEAn h\u1EC7'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'H\u1ECD t\xEAn ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: customerName,
              onChange: this.handleInputCustomer,
              onBlur: this.handleInputCustomerValidation
            }),
            customerNameError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              'T\xEAn kh\xF4ng h\u1EE3p l\u1EC7'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'Ch\u1EE9c v\u1EE5 ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: position,
              onChange: this.handleInputPosition,
              onBlur: this.handleInputPositionValidation
            }),
            positionError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              'Ch\u1EE9c v\u1EE5 kh\xF4ng \u0111\u01B0\u1EE3c \u0111\u1EC3 tr\u1ED1ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i ',
              _react2.default.createElement(
                'span',
                { className: styles.danger },
                '*'
              )
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: phoneNumber,
              onChange: this.handleInputPhone,
              onBlur: this.handleInputPhoneValidation
            }),
            phoneNumberError && _react2.default.createElement(
              'div',
              { className: styles.danger },
              'S\u1ED1 \u0111i\u1EC7n tho\u1EA1i kh\xF4ng h\u1EE3p l\u1EC7'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.fieldName },
            _react2.default.createElement(
              'div',
              { className: styles.label },
              'Email'
            ),
            _react2.default.createElement('input', {
              maxLength: '255',
              value: email,
              onChange: this.handleInputEmail
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.wrapButton },
            (error || this.props.error) && _react2.default.createElement(
              'div',
              { className: styles.danger },
              errorMessage ? errorMessage : 'Vui lòng kiểm tra lại dữ liệu nhập vào'
            ),
            !loading && _react2.default.createElement(
              'button',
              {
                className: styles.button,
                onClick: function onClick() {
                  return _this2.handleSetDataWillSent();
                }
              },
              '\u0110\u0103ng k\xFD'
            ),
            loading && _react2.default.createElement(
              'button',
              { className: styles.button },
              '\u0110ang g\u1EEDi...'
            )
          )
        )
      );
    }
  }]);
  return partnerRegistration;
}(_react.Component), _class2.propTypes = {
  submitDataPartner: _react.PropTypes.func,
  success: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  error: _react.PropTypes.bool,
  errorMessage: _react.PropTypes.any
}, _temp2)) || _class);
exports.default = partnerRegistration;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PartnerRegistration/PartnerRegistration.js
// module id = 1682
// module chunks = 0